import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IPartOperasyon } from './fiko-cam.types';
import { MALZEME_KESIM } from '../Fiko-2d-Cam/strategies/feeds-speeds';

/**
 * FikoYT CAM — Part Operation Setup (CATIA "Part Operation" muadili).
 * Makine tipi · work offset (G54-G59) · malzeme (Feeds&Speeds) · güvenlik Z · stok kutusu · eksen orijini —
 * hepsi tek kompakt kurulum penceresinde (eskiden kod-only idi).
 */
@Component({
  selector: 'fiko-cam-part-op-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="po-kok">
      <div class="po-bsl">🏭 Parça Operasyonu Kurulumu</div>

      <div class="po-grup">
        <label class="po-satir"><span>Ad</span><input type="text" [(ngModel)]="po.ad" (ngModelChange)="degisti()"/></label>
        <label class="po-satir"><span>Makine</span>
          <select [(ngModel)]="po.makineTip" (ngModelChange)="degisti()">
            <option value="3axis">3 Eksen (dik)</option>
            <option value="3axisHoriz">3 Eksen (yatay)</option>
            <option value="5axis">5 Eksen</option>
            <option value="lathe">Torna</option>
          </select>
        </label>
        <label class="po-satir"><span>Work Offset</span>
          <select [(ngModel)]="po.workOffset" (ngModelChange)="degisti()">
            @for(w of workOffsetler; track w){ <option [value]="w">{{ w }}</option> }
          </select>
        </label>
        <label class="po-satir"><span>Malzeme</span>
          <select [(ngModel)]="po.malzeme" (ngModelChange)="malzemeDegisti()">
            <option [ngValue]="undefined">— (takım varsayılanı)</option>
            @for(m of malzemeler; track m.k){ <option [value]="m.k">{{ m.ad }}</option> }
          </select>
        </label>
        <label class="po-satir"><span>Güvenlik Z</span><input type="number" step="1" [ngModel]="po.guvenlikZ" (ngModelChange)="guvenlikElle($event)"/><em>mm</em>
          <button class="po-3db" [class.bagli]="po.guvenlikZRef!=null" (click)="guvenlik3D();$event.preventDefault()" title="3D'den güvenlik düzlemini seç: yüze tıkla → yüz kotu + offset (referanslı — parça değişince takip eder)">🎯</button>
        </label>
        @if(po.guvenlikZRef!=null){
          <label class="po-satir"><span>+ Offset</span><input type="number" step="1" [ngModel]="po.guvenlikZOfset ?? 10" (ngModelChange)="guvenlikOfset($event)"/><em>mm</em></label>
          <div class="po-bagli">🔗 Yüz #{{ po.guvenlikZRef }} + offset — parça değişince güvenlik düzlemi takip eder</div>
        }
      </div>

      <div class="po-altbsl">Stok (Kütük)
        <button class="po-mini" (click)="stokOto()" title="Gövde bbox'ından otomatik stok">⚙ Otomatik</button>
      </div>
      @if(po.stok){
        <div class="po-grup po-stok">
          <label><span>En</span><input type="number" [(ngModel)]="po.stok!.en" (ngModelChange)="degisti()"/></label>
          <label><span>Boy</span><input type="number" [(ngModel)]="po.stok!.boy" (ngModelChange)="degisti()"/></label>
          <label><span>Yük</span><input type="number" [(ngModel)]="po.stok!.yuk" (ngModelChange)="degisti()"/></label>
          <label><span>X</span><input type="number" [(ngModel)]="po.stok!.x" (ngModelChange)="degisti()"/></label>
          <label><span>Y</span><input type="number" [(ngModel)]="po.stok!.y" (ngModelChange)="degisti()"/></label>
          <label><span>Z</span><input type="number" [(ngModel)]="po.stok!.z" (ngModelChange)="degisti()"/></label>
        </div>
      } @else { <div class="po-bos">Stok yok — ⚙ Otomatik ile oluştur</div> }

      <div class="po-altbsl">Eksen Orijini (G54 sıfır noktası)</div>
      <div class="po-grup po-stok">
        <label><span style="color:#f87171">X</span><input type="number" step="0.1" [(ngModel)]="po.eksenOrigin.x" (ngModelChange)="degisti()"/></label>
        <label><span style="color:#34d399">Y</span><input type="number" step="0.1" [(ngModel)]="po.eksenOrigin.y" (ngModelChange)="degisti()"/></label>
        <label><span style="color:#38bdf8">Z</span><input type="number" step="0.1" [(ngModel)]="po.eksenOrigin.z" (ngModelChange)="degisti()"/></label>
      </div>
      <div class="po-bilgi">NC/APT koordinatları bu eksene göre üretilir. Malzeme seçimi ⚡ Otomatik Feeds&Speeds hesabını besler.</div>

      <div class="po-alt">
        <button class="po-uygula" (click)="uygula()">✓ Uygula + Hesapla</button>
        <button class="po-kapat" (click)="kapat()">Kapat</button>
      </div>
    </div>
  `,
  styles: [`
    .po-kok{display:flex;flex-direction:column;gap:5px;color:#dbeafe;font-family:system-ui;width:236px;padding-bottom:2px;}
    .po-bsl{padding:5px 8px;font:700 10px system-ui;color:#bcd9ff;border-bottom:1px solid rgba(56,189,248,.2);}
    .po-grup{display:flex;flex-direction:column;gap:3px;padding:0 6px;}
    .po-satir{display:flex;align-items:center;gap:5px;background:rgba(10,20,35,.5);border:1px solid rgba(56,189,248,.22);border-radius:5px;padding:2px 6px;font:700 9px system-ui;}
    .po-satir span{min-width:58px;color:#9fc6ff;}
    .po-satir em{font-style:normal;color:#64748b;font-size:8px;}
    .po-satir input,.po-satir select{flex:1;width:100%;background:transparent;border:none;color:#fff;font:700 10px system-ui;font-variant-numeric:tabular-nums;text-align:right;outline:none;}
    .po-satir select{text-align:left;}
    .po-satir select option{background:#0b1626;color:#dbeafe;}
    .po-altbsl{display:flex;justify-content:space-between;align-items:center;padding:2px 8px 0;font:600 8px system-ui;color:#9fc6ff;text-transform:uppercase;letter-spacing:.4px;}
    .po-mini{background:rgba(10,20,35,.55);border:1px solid rgba(56,189,248,.35);border-radius:5px;color:#7ee0ff;font:700 8px system-ui;padding:2px 7px;cursor:pointer;}
    .po-mini:hover{background:rgba(20,45,70,.6);}
    .po-stok{display:grid;grid-template-columns:1fr 1fr 1fr;gap:3px;}
    .po-stok label{display:flex;align-items:center;gap:4px;background:rgba(10,20,35,.5);border:1px solid rgba(56,189,248,.22);border-radius:5px;padding:2px 5px;font:800 8px system-ui;color:#9fc6ff;}
    .po-stok input{width:100%;background:transparent;border:none;color:#fff;font:700 9px system-ui;font-variant-numeric:tabular-nums;text-align:right;outline:none;}
    .po-bos{padding:4px 8px;font:600 9px system-ui;color:#94a3b8;}
    .po-3db{flex:0 0 auto;background:rgba(0,80,110,.5);border:1px solid rgba(0,200,255,.35);border-radius:4px;color:#bfe6ff;cursor:pointer;font-size:9px;padding:1px 4px;margin-left:2px;}
    .po-3db:hover{background:rgba(0,130,170,.65);}
    .po-3db.bagli{border-color:#5eead4;box-shadow:0 0 6px rgba(94,234,212,.5);}
    .po-bagli{font:600 8px system-ui;color:#7fffd4;background:rgba(45,212,191,.1);border-radius:5px;padding:3px 6px;}
    .po-bilgi{margin:0 6px;font:600 8px system-ui;color:#9fe8d0;background:rgba(45,212,191,.08);border-radius:5px;padding:4px 6px;line-height:1.35;}
    .po-alt{display:flex;justify-content:space-between;align-items:center;gap:6px;padding:4px 8px;border-top:1px solid rgba(56,189,248,.18);}
    .po-uygula{flex:1;background:linear-gradient(135deg,rgba(22,135,90,.6),rgba(18,110,72,.55));border:1px solid rgba(52,211,153,.55);border-radius:6px;color:#a7f3d0;font:700 10px system-ui;padding:4px 10px;cursor:pointer;}
    .po-uygula:hover{filter:brightness(1.15);}
    .po-kapat{background:rgba(10,20,35,.55);border:1px solid rgba(148,163,184,.35);border-radius:6px;color:#cbd5e1;font:700 10px system-ui;padding:4px 10px;cursor:pointer;}
  `]
})
export class FikoCamPartOpDialog {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() pencere: any;
  constructor(public CD: ChangeDetectorRef) {}
  get po(): IPartOperasyon { return this.element || this.yonetici?.partOp; }
  readonly workOffsetler = ['G54', 'G55', 'G56', 'G57', 'G58', 'G59'];
  readonly malzemeler = Object.entries(MALZEME_KESIM).map(([k, v]) => ({ k, ad: v.ad }));

  degisti(): void { this.yonetici?.durumKaydet?.(); this.CD.markForCheck(); }
  malzemeDegisti(): void {
    // Malzeme değişti → tüm operasyonların hız/ilerlemesini yeniden hesapla (Vc/fz tablodan)
    for (const op of this.po?.operasyonlar || []) { op.hizlar.kesimHiz = undefined as any; op.hizlar.disBasinaIlerleme = undefined as any; this.yonetici?.hizHesapla?.(op); }
    this.degisti();
  }
  stokOto(): void { this.yonetici?.stokOtomatik?.(); this.degisti(); }
  /** Güvenlik düzlemini 3D sahneden yüz seçerek belirle (CATIA — referanslı, offset'li). */
  guvenlik3D(): void { this.yonetici?.partGuvenlikSecBaslat?.(() => this.CD.markForCheck()); }
  /** Elle sayı girildi → yüz bağlantısı kopar (associatif çözüm eski kotu geri yazmasın). */
  guvenlikElle(v: any): void { const n = +v; if (!Number.isFinite(n)) return; this.po.guvenlikZ = n; delete this.po.guvenlikZRef; this.degisti(); }
  guvenlikOfset(v: any): void {
    const n = +v; if (!Number.isFinite(n)) return; this.po.guvenlikZOfset = n;
    if (this.po.guvenlikZRef != null) this.yonetici?.hesapla?.();   // referanslıysa güvenlik Z yeniden çözülür
    this.degisti();
  }
  uygula(): void { this.yonetici?.hesapla?.(); this.yonetici?.durumKaydet?.(); this.kapat(); }
  kapat(): void { this.pencere?.kapat?.(); }
}
